import * as React from 'react';
import { UitkEmptyState } from 'uitk-react-empty-state';
import { liveAnnounce } from 'uitk-react-utils';

import { FlightsShoppingPwaFlightSearchResultsFlightsSearch } from '__generated__/api';
import NoListingMessaging = FlightsShoppingPwaFlightSearchResultsFlightsSearch.NoListingMessaging;
import NFFMessageWithFilters = FlightsShoppingPwaFlightSearchResultsFlightsSearch.FlightsNoFlightsFoundWithFilterMessagingInlineFragment;

import { ViewSmall, Viewport, ViewLarge } from 'bernie-view';
import { useStores } from 'utility/hooks';
import { trackAnalytics } from 'utility';

interface NoFlightsFoundMessagingProps {
  noListingMessaging: NoListingMessaging;
}

export const NoFlightsFoundMessaging = ({ noListingMessaging }: NoFlightsFoundMessagingProps) => {
  const { icon, title, message } = noListingMessaging;
  const clearFiltersAction =
    noListingMessaging.__typename === 'FlightsNoFlightsFoundWithFilterMessaging' &&
    (noListingMessaging as NFFMessageWithFilters).clearFiltersAction;
  const { id } = icon;
  const { routeStore, context, advertisingStore, searchCriteriaStore, analytics, sortFilterStore } = useStores();
  const { clearAllSelectionLabel } = sortFilterStore;

  const clearFilters = (): void => {
    sortFilterStore.clearFilters();
    sortFilterStore.applySortAndFilter(searchCriteriaStore, routeStore, advertisingStore, context, analytics);
    trackAnalytics(clearAllSelectionLabel.analytics, analytics);
    liveAnnounce(clearAllSelectionLabel.accessibility.onCompletion);
  };

  return (
    <div className="uitk-type-center all-y-padding-three" data-test-id="nff-message-container">
      <Viewport>
        <ViewLarge>
          <UitkEmptyState icon={id} heading={title} headingLevel="h2" body={message} className="all-x-margin-twelve" />
        </ViewLarge>
        <ViewSmall>
          <UitkEmptyState
            icon={id}
            heading={title}
            headingLevel="h2"
            body={message}
            className="all-x-margin-twelve"
            buttonText={
              noListingMessaging.__typename === 'FlightsNoFlightsFoundWithFilterMessaging'
                ? clearFiltersAction.displayAction
                : undefined
            }
            onClick={
              noListingMessaging.__typename === 'FlightsNoFlightsFoundWithFilterMessaging' ? clearFilters : undefined
            }
          />
        </ViewSmall>
      </Viewport>
    </div>
  );
};

export default NoFlightsFoundMessaging;
